import { rem } from 'polished'
import React, { FC } from 'react'
import { SimpleProps } from '.'
import { Box } from '../Layout'
import * as S from './elements'

const Simple: FC<SimpleProps> = ({ variant, label }) => {
  return (
    <Box
      display="grid"
      gridTemplateColumns={[`${rem(40)} auto`, `${rem(56)} auto`]}
      gridColumnGap={['.75rem', '1rem']}
      alignItems="center"
    >
      <S.Icon icon="check"></S.Icon>

      <Box overflow="hidden">
        <S.Label mb={0} fontWeight={600}>
          {label}
        </S.Label>
      </Box>
    </Box>
  )
}

export default Simple
